module.exports = __webpack_public_path__ + "img/balloon_ride_half.74b0d19b.svg";